export default __webpack_public_path__ + "static/media/right-6.9ef4a206.png";